import React from "react"
import PropTypes from "prop-types"
import "bootstrap/dist/css/bootstrap.min.css"
import "react-day-picker/lib/style.css"
import "dropzone/dist/min/dropzone.min.css"
import "../content/assets/nav-slide-effect.css"
import "../content/assets/font-awesome.min.css"
import "../content/NewUIHomeFlexi.css"
import "../content/font.css"
import EtiqaHeader from "./etiqaHeader.js"
import GatsbyConfig from "../../gatsby-config"

import "../content/Site.css"
if(process.env.THEME == "Etiqa") {
  require("../content/ThemeYellow.css"); // Etiqa theme CSS
}

const themeLogo = GatsbyConfig.siteMetadata.themeLogo
let logo = require("../content/img/" + themeLogo)

const sharedLayout = ({ children }) => {
  return (
    <>
      <EtiqaHeader logo={logo} claimFormTitle={""} />
      <div>
        <main>{children}</main>
      </div>
    </>
  )
}

sharedLayout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default sharedLayout
